const globalInitState = {
  value: 0,
  status: 'idle'
};

export default globalInitState;
